import {EnumActionType} from "../api";

export const getTypAkceCaption = (typ: EnumActionType): string => {
    switch (typ) {
        case EnumActionType.INSERT:
            return 'Vytvoření';
        case EnumActionType.UPDATE:
            return 'Úprava';
        case EnumActionType.DELETE:
            return 'Smazání';
        default:
            return `${typ}`;
    }
};